import React, { useState, useEffect } from "react";
import ProvaAccordionSection from "../components/multitessere/ProvaAccordionSection";
import DueMultitessereSezioni from "../components/multitessere/DueMultitessereSezioni";
import foto1 from "../images/multitessere.png";
import Titolo from "../commons/Titolo";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import Space from "../commons/Space";
import SpaceL from "../commons/SpaceL";
import AllertIscrizione from "../components/multitessere/AllertIscrizione";
import AccordionSmall from "../components/multitessere/AccordionSmall";
import CardInEvidenza from "../components/CardInEvidenza";
import promo from "../images/News/Promo_fine_stagione.png";
import barista from "../images/News/Barista.png";
import CardNewsEvidenza from "../components/CardNewsEvidenza";
import Spa from "./Spa";
import workinprogress from "../images/work-in-progress.png";
import {Helmet} from "react-helmet";

function Multitessere() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div>
            <Helmet>
                <title>Multitessere</title>
                <meta name="description" content="Scopri la formula di abbonamento più adatta a te" />
            </Helmet>
            <ScrollToTopOnMount />
            <Titolo backgroundImage={foto1} title={"MULTITESSERE"}/>
            <SpaceL />
            {/*
            <figure className="text-center">
                <blockquote className="blockquote">
                    <p style={{fontSize: "30px", padding:"1em", fontFamily: "Hammersmith One"}}>
                        <img src={workinprogress} style={{width: "3em", margin: "auto"}}></img>
                        <br/>
                        <br/>
                        Pagina in aggiornamento... :)
                    </p>
                </blockquote>
            </figure>

            <Space />
            <Space />
            <Space />
            <Space />
            */}
            <figure className="text-center">
                <blockquote className="blockquote">
                    <h3 style={{fontSize: "30px", padding:"1em"}}>Scegli la formula di abbonamento più adatta a te </h3>
                </blockquote>
            </figure>

            {windowWidth > 900 ? (
                <DueMultitessereSezioni />
            ) : (
                <AccordionSmall />
            )}
            <SpaceL />
            <AllertIscrizione />
            <Space />

            <Space />



        </div>
    );
}

export default Multitessere;
